import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import CommentsModal from "../CommentsModal";
import {commentingApi} from '../../helpers/commentingFetcher'
import {capitalizeFirstLetter} from '../../helpers/utils'
import {finalTranslations} from '../../localTranslation'
import { ACTIONS } from '../../store/Actions'
import {DataContext} from '../../store/GlobalState'
import {isEmpty} from '../../helpers/utils'
import { getUserId } from '@futures-platform/connectors/session'
import styles from './Comments.module.css'
import { votingApi } from '../../helpers/fetcher';

const Comments = ({gid, rid, pid, lang, phenomenon, likingOn, commentsOn, isTranslated, langForTransState}) => {
  const {state:{ cmtsData , getTheWholeCardHtmlElms},  dispatch } = useContext(DataContext)
  const cmtsData1 = !!cmtsData?.length ? [...cmtsData] : []
          !!cmtsData1?.length && cmtsData1?.map((cmt) => {
            if (getUserId().toString() === cmt.uid.toString()) {
                cmt['isAuthor'] = true
              } else {
                cmt['isAuthor'] = false
              }
          })
  const [openCommentsModal, setOpenCommentsModal] = useState(false);
  const [commentTopic, setCommentTopic] = useState(null)

  const cardHeaderTitleRef = useRef()
  const opportunitiesCmtsRef = useRef()
  const threatsCmtsRef = useRef()
  const actionsCmtsRef = useRef()
  const cardBtnRef = useRef()

  const cardHeaderTitleRef2 = useRef()
  const opportunitiesCmtsRef2 = useRef()
  const threatsCmtsRef2 = useRef()
  const actionsCmtsRef2 = useRef()
  const cardBtnRef2 = useRef()

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(null)
  const [opportunitiesTrans, setopportunitiesTrans] = useState(null)
  const [threatsTrans, setthreatsTrans] = useState(null)
  const [actionsTrans, setactionsTrans] = useState(null)
  const [cardBtn, setcardBtn] = useState(null)

  
  const openCommentsModalHandle = () => {
    setOpenCommentsModal(true);
  };

  const closeCommentsModalHandle = () => {
    setOpenCommentsModal(false);
  };

  
  const opportunitiesCmts = useMemo(() => {
    const a = !!cmtsData1?.length && cmtsData1?.map((cmt) => {
      const date = new Date(+cmt?.['updated_timestamp'] * 1000);
      const cmtTemp = (!!cmt && !isEmpty(cmt)) ? {...cmt} : {};
      cmtTemp['updated_humanTime'] = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '.').replace(',', '');
      return cmtTemp
    }).filter((cmt) => {
      return String(cmt?.entity_uri?.split('/')[7]) === 'opportunities'
    })
    return !!a?.length && a?.sort(function(x, y){
      return x.created_timestamp - y.created_timestamp;
  })
  }, [cmtsData, dispatch])

  const threatsCmts = useMemo(() => {
    const a = !!cmtsData1?.length && cmtsData1?.map((cmt) => {
      const date = new Date(+cmt?.['updated_timestamp'] * 1000);
      const cmtTemp = (!!cmt && !isEmpty(cmt)) ? {...cmt} : {};
      cmtTemp['updated_humanTime'] = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '.').replace(',', '');
      return cmtTemp
    }).filter((cmt) => {
      return String(cmt?.entity_uri?.split('/')[7]) === 'threats'
    })
    return !!a?.length && a?.sort(function(x, y){
      return x.created_timestamp - y.created_timestamp;
  })
  }, [cmtsData, dispatch])

  const actionsCmts = useMemo(() => {
    const a = !!cmtsData1?.length && cmtsData1?.map((cmt) => {
      const date = new Date(+cmt?.['updated_timestamp'] * 1000);
      const cmtTemp = (!!cmt && !isEmpty(cmt)) ? {...cmt} : {};
      cmtTemp['updated_humanTime'] = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '.').replace(',', '');
      return cmtTemp
    }).filter((cmt) => {
      return String(cmt?.entity_uri?.split('/')[7]) === 'actions'
    })
    return !!a?.length && a?.sort(function(x, y){
      return x.created_timestamp - y.created_timestamp;
  })
  }, [cmtsData, dispatch])


  useEffect(() => {
    const fetcher = async () => {
      const [res1, res2, res3, res4, res5] = await Promise.all([
        (originalTitle || cardHeaderTitleRef2.current) && votingApi.translation("en", langForTransState, originalTitle || cardHeaderTitleRef2.current),
        (opportunitiesTrans ||  opportunitiesCmtsRef2.current) && votingApi.translation("en", langForTransState, opportunitiesTrans ||  opportunitiesCmtsRef2.current),
        (threatsTrans || threatsCmtsRef2.current) && votingApi.translation("en", langForTransState, threatsTrans || threatsCmtsRef2.current),
        (actionsTrans || actionsCmtsRef2.current) && votingApi.translation("en", langForTransState, actionsTrans || actionsCmtsRef2.current),
        (cardBtn || cardBtnRef2.current) && votingApi.translation("en", langForTransState, cardBtn || cardBtnRef2.current)
      ])
      settranslations(() => {
        return {
          res1, res2, res3, res4, res5
        }
      })
      
    };
    !!isTranslated && !!originalTitle && !!cardBtn && opportunitiesTrans && threatsTrans && actionsTrans && fetcher();
    
  }, [actionsTrans, cardBtn, isTranslated, opportunitiesTrans, originalTitle, threatsTrans, langForTransState])

  useEffect(() => {
    if (!!phenomenon) {
      if (true) {
        if(!!cardHeaderTitleRef.current?.innerHTML && !cardHeaderTitleRef2.current) {
          cardHeaderTitleRef2.current = cardHeaderTitleRef.current?.innerHTML
        }
        if(!!opportunitiesCmtsRef.current?.innerHTML && !opportunitiesCmtsRef2.current) {
          opportunitiesCmtsRef2.current = opportunitiesCmtsRef.current?.innerHTML
        }
        if(!!threatsCmtsRef.current?.innerHTML && !threatsCmtsRef2.current) {
          threatsCmtsRef2.current = threatsCmtsRef.current?.innerHTML
        }
        if(!!actionsCmtsRef.current?.innerHTML && !actionsCmtsRef2.current) {
          actionsCmtsRef2.current = actionsCmtsRef.current?.innerHTML
        }
        if(!!cardBtnRef.current?.innerHTML && !cardBtnRef2.current) {
          cardBtnRef2.current = cardBtnRef.current?.innerHTML
        }
        cardHeaderTitleRef2.current && setoriginalTitle(() => cardHeaderTitleRef2.current)
        opportunitiesCmtsRef2.current && setopportunitiesTrans(() => opportunitiesCmtsRef2.current)
        threatsCmtsRef2.current && setthreatsTrans(() => threatsCmtsRef2.current)
        actionsCmtsRef2.current && setactionsTrans(() => actionsCmtsRef2.current)
        cardBtnRef2.current && setcardBtn(() => cardBtnRef2.current)
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD5,
        //   payload: true
        // })
      }
    }
  }, [dispatch, isTranslated, phenomenon])


  return (
    <>
      { !!commentsOn && (
        <>
            <div className={styles.commentsWrapper}>
            {
              !isTranslated && (
                <h3 className={styles.h3Title} ref={cardHeaderTitleRef}>{lang === 'fi' ? finalTranslations?.commenting?.fi : finalTranslations?.commenting?.en}</h3>
              )
            }
            {
              !!isTranslated && (
                <h3 className={styles.h3Title} ref={cardHeaderTitleRef} dangerouslySetInnerHTML={{__html: translations?.res1?.data}}></h3>
              )
            }
            <div>
              <div className={styles.sectionWrapper}>
                {
                  !isTranslated && (
                    <p className={styles.sectionTitle} ref={opportunitiesCmtsRef}>{lang === 'fi' ? finalTranslations?.opportunitiesCommentSection?.fi : finalTranslations?.opportunitiesCommentSection?.en}</p>
                  )
                }
                {
                  !!isTranslated && (
                    <p className={styles.sectionTitle} ref={opportunitiesCmtsRef} dangerouslySetInnerHTML={{__html: translations?.res2?.data}}></p>
                  )
                }
                <p
                  className={styles.commentsViewText}
                  onClick={() => {
                      setCommentTopic('Opportunities');
                      openCommentsModalHandle();
                  }}
                >
                  <span className={clsx(styles.chatIcon, 'af-custom-chat')}></span>
                  {
                    !isTranslated && (
                      <div ref={cardBtnRef}>
                        {lang === 'fi' ? finalTranslations?.commentViewBtn?.fi : finalTranslations?.commentViewBtn?.en}
                      </div>
                    )
                  }
                  {
                    !!isTranslated && (
                      <div ref={cardBtnRef} dangerouslySetInnerHTML={{__html: translations?.res5?.data}}>
                        
                      </div>
                    )
                  }
                </p>
              </div>
              <>
                  {
                    opportunitiesCmts && !!opportunitiesCmts?.length && (
                      <div className={styles.userCommentArea}>
                        <p className={styles.userNameTitle}>
                          {capitalizeFirstLetter(
                            !!opportunitiesCmts[opportunitiesCmts?.length - 1]?.['comment_name'] ? 
                            opportunitiesCmts[opportunitiesCmts?.length - 1]?.['comment_name'] :
                            opportunitiesCmts[opportunitiesCmts?.length - 1]?.['user_name']
                          )} 
                            {" "} 
                              <span className={styles.cmtTimeStamp}>{opportunitiesCmts[opportunitiesCmts?.length - 1]['updated_humanTime']}</span> </p>
                        <p className="pt_4 pb_4 ">{opportunitiesCmts[opportunitiesCmts?.length - 1]?.['comment_text']}</p>
                      </div>
                    )
                  }
              </>


              <div className={styles.sectionWrapper}>
                {
                  !isTranslated && (
                    <p className={styles.sectionTitle} ref={threatsCmtsRef}>{lang === 'fi' ? finalTranslations?.threatsCommentSection?.fi : finalTranslations?.threatsCommentSection?.en}</p>
                  )
                }
                {
                  !!isTranslated && (
                    <p className={styles.sectionTitle} ref={threatsCmtsRef} dangerouslySetInnerHTML={{__html: translations?.res3?.data}}></p>
                  )
                }
                <p
                  className={styles.commentsViewText}
                  onClick={() =>{
                    setCommentTopic('Threats');
                    openCommentsModalHandle();
                  }}
                >
                  <span className={clsx(styles.chatIcon, 'af-custom-chat')}></span>
                  {
                    !isTranslated && (
                      <div ref={cardBtnRef}>
                        {lang === 'fi' ? finalTranslations?.commentViewBtn?.fi : finalTranslations?.commentViewBtn?.en}
                      </div>
                    )
                  }
                  {
                    !!isTranslated && (
                      <div ref={cardBtnRef} dangerouslySetInnerHTML={{__html: translations?.res5?.data}}>
                        
                      </div>
                    )
                  }
                </p>
              </div>

              <>
                  {
                    threatsCmts && !!threatsCmts?.length && (
                      <div className={styles.userCommentArea}>
                        <p className={styles.userNameTitle}>
                          {capitalizeFirstLetter(!!threatsCmts[threatsCmts?.length - 1]?.['comment_name'] ? 
                            threatsCmts[threatsCmts?.length - 1]?.['comment_name'] :
                            threatsCmts[threatsCmts?.length - 1]?.['user_name'])} 
                            {" "} 
                            <span className={styles.cmtTimeStamp}>{threatsCmts[threatsCmts?.length - 1]['updated_humanTime']}</span> </p>
                        <p className="pt_4 pb_4 ">{threatsCmts[threatsCmts?.length - 1]?.['comment_text']}</p>
                      </div>
                    )
                  }
              </>



              <div className={styles.sectionWrapper}>
                {
                  !isTranslated && (
                    <p className={styles.sectionTitle} ref={actionsCmtsRef}>{lang === 'fi' ? finalTranslations?.actionsCommentSection?.fi : finalTranslations?.actionsCommentSection?.en}</p>
                  )
                }
                {
                  !!isTranslated && (
                    <p className={styles.sectionTitle} ref={actionsCmtsRef} dangerouslySetInnerHTML={{__html: translations?.res4?.data}}></p>
                  )
                }
                <p
                  className={styles.commentsViewText}
                  onClick={() => {
                    setCommentTopic('Actions');
                    openCommentsModalHandle();
                  }}
                >
                  <span className={clsx(styles.chatIcon, 'af-custom-chat')}></span>
                  {
                    !isTranslated && (
                      <div ref={cardBtnRef}>
                        {lang === 'fi' ? finalTranslations?.commentViewBtn?.fi : finalTranslations?.commentViewBtn?.en}
                      </div>
                    )
                  }
                  {
                    !!isTranslated && (
                      <div ref={cardBtnRef} dangerouslySetInnerHTML={{__html: translations?.res5?.data}}>
                        
                      </div>
                    )
                  }
                </p>
              </div>
              <>
                  {
                    actionsCmts && !!actionsCmts?.length && (
                      <div className={styles.userCommentArea}>
                        <p className={styles.userNameTitle}>
                          {capitalizeFirstLetter(!!actionsCmts[actionsCmts?.length - 1]?.['comment_name'] ? 
                            actionsCmts[actionsCmts?.length - 1]?.['comment_name'] :
                            actionsCmts[actionsCmts?.length - 1]?.['user_name'])} 
                            {" "} 
                            <span className={styles.cmtTimeStamp}>{actionsCmts[actionsCmts?.length - 1]['updated_humanTime']}</span> </p>
                        <p className="pt_4 pb_4 ">{actionsCmts[actionsCmts?.length - 1]?.['comment_text']}</p>
                      </div>
                    )
                  }
              </>

            </div>
          </div>
          <CommentsModal
            likingOn={likingOn}
            id='commentsModal'
            // commentsModalSubmit={closeCommentsModalHandle}
            commentsModal={openCommentsModal}
            commentTopic={commentTopic}
            commentsModalClose={closeCommentsModalHandle}
            gid={gid} 
            rid={rid} 
            pid={pid}
            lang={lang}
            phenomenon={phenomenon}
            cmts={ !!commentTopic && (commentTopic === 'Opportunities' ? opportunitiesCmts : (commentTopic === 'Actions' ? actionsCmts : threatsCmts))}
          />
            </>
          )}
        </>
  );
};

export default Comments;
